import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import EtfListDisplay from './EtfListDisplay';

class EtfWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Exchange Traded Fund (ETF) Screener</title> 
          <link rel="canonical" href="https://www.vizfm.com/etf" />
          <meta name="description" content="Exchange Traded Fund (ETF) Screener for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row><Col>Exchange Traded Fund (ETF) Screener</Col></Row>
          <Row>
            <Col><EtfListDisplay /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default EtfWrap;
